import { FormattedMessage } from 'react-intl';

export const FreePeriodBadge = () => (
  <span className="inline-flex w-fit rounded-full bg-primary-100 px-2 py-0.5 text-sm font-medium text-primary-800">
    <FormattedMessage defaultMessage="Kostnadsfri" />
  </span>
);
